module.exports = __webpack_public_path__ + "media/images/weather/219_night-c3419ce892291e85c307a4a9b8469ba8.png";